/**
 * Application configuration
 */

export const config = {
  azureTenantId: import.meta.env.VITE_AZURE_TENANT_ID || '3b368a0f-0a46-4052-84a3-88cc6bd9ae1f',
  azureClientId: import.meta.env.VITE_AZURE_CLIENT_ID || '077fb100-20d8-45af-a3ac-61a66d4392a7',
};
